
<template>

  <div id="parameterModalPopupBox" class="modalPopup">
    <div class="modal-popup-content">
      <div class="modal-popup-header">
        <span class="modal_close" v-on:click="closeParameterModal">×</span>
        <h2>Individual Parameters of {{parameterModalData.title}}</h2>
      </div>
      <div class="modal-popup-main">
		<table>
			<tr>
				<th>Time period</th>
				<th v-for="(value, parameterName, index) in parameters[0]" :key="index">{{parameterName}}</th>
			</tr>
			<tr v-for="(parameterValues, periodIndex) in parametersFiltered" :key="periodIndex">
				<td>{{periodIndex}}</td>
				<td v-for="(parameterValue, parameterName, index) in parameters[periodIndex]" :key="index"><input type="number" :placeholder="parameterName+periodIndex" v-model.number="parameters[periodIndex][parameterName]"/></td>
			</tr>
		</table>
      </div>
    </div>
  </div>

</template>


<script>

  /* 

    The format of the modalData
    ---------------------------
    {
      isParameterModalShown: true, 
      parameterModalData: {
        parameterData: ...,
        title: 'PLACEHOLDER'
      }
    }
  
   */

  import Vue from 'vue';
  import timeSlices from '../../util/density/timeSlices';
  import compile from '../../util/compile';

  export default {

    name: 'ParameterModal',
    props: ['parameterModalData'],
    data: () => {
      return {
        parameters: [],
		title: undefined,
		nodeid: undefined
      }
    },
	computed: {
		parametersFiltered: function () {
			return this.parameters.filter(function (arr, idx) {
				return idx < timeSlices();
			})
		}
	},
	mounted() {
		this.parameters = this.parameterModalData.parameterData;
		this.title = this.parameterModalData.title;
		this.nodeid = this.parameterModalData.nodeid;
	},
    methods: {

		// The method below is called when the user clicks the 'x' in the popup.
		// See the v-on:click directive
		closeParameterModal(){
			
			// search node to write data
			let nodeElement = this.$parent.editor.nodes.find(n => n.id == this.nodeid);
			
			//write input fields (visible on node)
			for( let parameterName in this.parameters[0]){
				nodeElement.controls.get(parameterName).setValue(this.parameters[0][parameterName]);
				nodeElement.data[parameterName] = this.parameters[0][parameterName];
			}
			//write all data in array form to node
			nodeElement.data.parameters = [...this.parameters];
			
			Vue.prototype.$eventHub.$emit("showParameterModal", {isParameterModalShown: false});
			
			let engine = this.$parent.engine;
			let editor = this.$parent.editor;
			
			compile({engine, editor});
			
		}
    }
  }

</script>


<style scoped>

/* Scrollbar */

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888; 
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

/* Popup Box */
  
  #modalPopupBox {
    z-index: 99999999;
  }

  /* mPopup box style */
  .modalPopup {
    position: fixed;
    z-index: 200;
    padding-top: 50px;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: rgb(0,0,0);
    background-color: rgba(0,0,0,0.4);
  }

  .modal-popup-content {
    position: relative;
    background-color: #fefefe;
    margin: auto;
    padding: 0;
    width: 500px;
    box-shadow: 0 4px 8px 0 rgba(0,0,0,0.2),0 6px 20px 0 rgba(0,0,0,0.19);
    -webkit-animation-name: animatetop;
    -webkit-animation-duration: 0.4s;
    animation-name: animatetop;
    animation-duration: 0.4s
  }

  .modal-popup-header {
    padding: 2px 16px;
    background-color: #51A7DD;
    color: white;
  }

  .modal-popup-main {
    /* This is the part of the pop-up underneath the pop-up header */

    padding: 20px 16px;
    overflow:auto;

  }

  .modal-footer {
    padding: 2px 16px;
    background-color: #999999;
    color: #ffffff;
    font-family: monospace;
    font-size: 12px;
  }

    /* close button style */
  .modal_close {
    color: white;
    float: right;
    font-size: 28px;
    font-weight: bold;
  }
  .modal_close:hover, .modal_close:focus {
    color: #000;
    text-decoration: none;
    cursor: pointer;
  }

  
</style>